/**
 * Class for suggest an stop.
 */

import { getResourceTo, toastNotification } from 'react/utils/utils';


Greenmile.RouteDetail = Greenmile.RouteDetail || {};

const { stopDetailsGeocodeStop, stopDetailsPopup } = window.actions;

Greenmile.RouteDetail.SuggestGeocodeStop = function (routeId, map, sessionData) {

    var rootNode = document.getElementById('routeMaps_' + routeId);
    var STOP_SUGGESTION_KIND = 'STOP_SUGGESTIONS';
    this.rootEl = rootNode.querySelector('.suggestGeocodeStop');

    sessionData.editingStop = sessionData.editingStop || {};

    var distanceFormatted = function (latLngBegin, latLngEnd) {

        var awayResource = Monet.I18n.getResourcesByKey('Greenmile.SuggestGeocodeStop.away');
        var distance = L.latLng(latLngBegin).distanceTo(latLngEnd);
        var distanceFormatted = new Monet.Format.DISTANCE(distance).toGrid().getValue();

        if (distanceFormatted) {
            distanceFormatted += ' ' + awayResource;
        }

        return distanceFormatted;
    };

    var renderContentPopup = function (context) {

        return function (marker) {

            var popupContent;
            var stop = context.data;
            var geocodePopup = new Greenmile.RouteDetail.GeocodeStop(routeId, map);
            const lat = stop.latitude || stop.location.latitude;
            const lng = stop.longitude || stop.location.longitude;
            var latLongStop = [lat, lng];
            var endPosition = [marker._latlng.lat, marker._latlng.lng];

            popupContent = new Greenmile.RouteDetail.PopupToGeocode(routeId, marker, stop.id);
            geocodePopup.setCorrectLocation(endPosition[0], endPosition[1]).setStop(stop);
            popupContent.setPositionToSave({ latitude: endPosition[0], longitude: endPosition[1] });
            popupContent.setCallbackToSaveAndReprocess(function () {
                popupContent.renderGeocode();
                popupContent.getAutoArriveConfigurationAndRenderPopupInfoToReprocess();
            });
            return L.popup({
                offset: new L.Point(0, 25),
                minWidth: 345,
                maxWidth: 600
            }).setContent(popupContent.render(latLongStop, endPosition));

        };
    }(this);

    var renderSectionSuggestionOfGoogle = function () {
        var container = document.createElement('ul');
        container.className = 'sectionSuggestFromGoogle';

        return container;

    };

    var renderSectionEquipmentStopped = function () {
        var container = document.createElement('div');
        var containerUl = document.createElement('ul');
        var textContainerEquipment = document.createElement('span');
        var textSection = document.createTextNode(Monet.I18n.getResourcesByKey('Greenmile.SuggestGeocodeStop.suggestByEquipmentStopped'));

        textContainerEquipment.className = 'ellipsis';
        textContainerEquipment.appendChild(textSection);

        container.className = 'sectionSuggestFromEquipmentStopped';
        container.appendChild(textContainerEquipment);
        container.appendChild(containerUl);

        return container;

    };

    var getClassToStatusStop = function (stop) {

        var statusStop = {
            DELIVERED: "stopComplete",
            REDELIVERED: "stopRedeliveryStop",
            UNDELIVERED: "stopUndeliverable",
            CANCELED: "stopCancel",
            PENDING: "stopPending",
            IN_PROGRESS: 'stopsInProgress'
        };

        return statusStop[stop.status] || statusStop.PENDING;
    };

    var renderSectionHeader = function (stop) {

        var container = document.createElement('div');
        var stopStatusContainer = document.createElement('div');
        var locationContainer = document.createElement('div');
        var closeSuggest = document.createElement('div');
        var stopStatus = getClassToStatusStop(stop);
        var infoLocation = stop.location.key + ' - ' + stop.location.description;

        container.className = 'headerStopDetail';
        closeSuggest.className = 'closeStopIcon';
        stopStatusContainer.className = 'popupStatus ' + stopStatus;

        locationContainer.className = 'locationInfo';
        locationContainer.title = infoLocation;
        locationContainer.innerHTML = infoLocation;

        closeSuggest.addEventListener('click', function () {
            rootNode.removeChild(container.parentNode);
            Greenmile.Map.Utility.removeLayerByKind(map, [STOP_SUGGESTION_KIND]);
        });

        container.appendChild(stopStatusContainer);
        container.appendChild(locationContainer);
        container.appendChild(closeSuggest);

        return container;

    };

    var appendSuggestion = function (textContent, position) {

        var itemHtml = document.createElement('li');
        var labelContent = document.createElement('label');
        var iconContainer = document.createElement('div');

        labelContent.innerHTML = textContent;
        labelContent.title = textContent;
        labelContent.className = 'ellipsis';
        iconContainer.className = 'icon';

        itemHtml.appendChild(labelContent);
        itemHtml.appendChild(iconContainer);
        itemHtml.addEventListener('click', function () {
            Greenmile.Map.Utility.setMarkerFocus(sessionData, { lat: position.latitude, lng: position.longitude });;
        });

        return itemHtml;
    };

    var renderMarkerToGoogleSuggestOnMap = function (position, iconUrl) {

        var googlePosition = [position.latitude, position.longitude];
        var marker = new L.marker(googlePosition, {
            icon: new L.icon({
                iconUrl: iconUrl,
                iconSize: [15, 26],
                popupAnchor: [37, -20]
            })
        });

        marker.kind = STOP_SUGGESTION_KIND;
        marker.bindPopup(renderContentPopup(marker), {
            maxWidth: 600,
            className: 'geocode-popup'
        });

        return marker;

    };

    var appendSuggestionOfGoogle = function (context) {
        return function (results) {
            var arrayMarkers = [];
            const stopId = context.data.id;
            window.GreenmileReduxStore.dispatch(stopDetailsPopup.completeGoogleSuggestions(routeId, stopId, results));
            results.forEach(function (item) {
                var latLng = item.geometry.location;
                var position = { latitude: latLng.lat(), longitude: latLng.lng() };
                arrayMarkers.push(renderMarkerToGoogleSuggestOnMap(position, require("static/images/map/markers/generic_marker_blue.png")));
            });
            map._addLayers(arrayMarkers);
        };
    }(this);

    var renderSuggestionByEquipmentStopped = function (context) {

        return function (coordinates) {

            if (context && context.rootEl) {
                var sectionEquipmentStop = context.rootEl.querySelector('.sectionSuggestFromEquipmentStopped ul');
                var fragment = document.createDocumentFragment();
                var renderContent = function (item) {
    
                    var timeArrival = Monet.Format.Time.formatToLocale(item.get('date'));
                    var timeDeparture = Monet.Format.Time.formatToLocale(item.get('nextCoordinateDate'));
                    var elapsedTime = new Monet.Format.MILLISECONDS(item.get('diffTime')).formatToElapsedTime().getValue();
                    var latLngBegin = [context.data.latitude, context.data.longitude];
                    var latLngEnd = [item.get('position').latitude, item.get('position').longitude];
    
                    return timeArrival + ' - ' + timeDeparture + ', ' + elapsedTime + ' ' + distanceFormatted(latLngBegin, latLngEnd);
    
                };
    
                coordinates.models.forEach(function (item) {
                    fragment.appendChild(appendSuggestion(renderContent(item), item.get('position')));
                });
                sectionEquipmentStop.innerHTML = '';
                sectionEquipmentStop.appendChild(fragment);
            }
        };

    }(this);

    var noResultsFromGoogleSuggestion = function (context) {

        return function () {
            var sectionGoogle = context.rootEl.querySelector('.sectionSuggestFromGoogle');
            var liContent = document.createElement('li');
            var labelContent = document.createElement('label');
            var textToLabel = Monet.I18n.getResourcesByKey('Greenmile.RouteDetail.noResultsToGoogleGeocode');

            labelContent.className = 'ellipsis';
            labelContent.title = textToLabel;
            labelContent.appendChild(document.createTextNode(textToLabel));
            liContent.appendChild(labelContent);
            sectionGoogle.appendChild(liContent);

        };

    }(this);

    const errorOnRequestGoogleSuggestion = function () {
        toastNotification.addToast({
            id: 'error-on-google-suggestion',
            type: 'warning',
            data: {
            title: getResourceTo('alertgenericmodal.header.title.default'),
            description: getResourceTo('Greenmile.RouteDetail.errorOnGetGoogleSuggestion'),
            }
        });
    }

    var renderResultGoogleSuggestionByStatus = function (results, status) {
        switch (status) {
            case "OK":
                appendSuggestionOfGoogle(results);
            break;
            default :
                errorOnRequestGoogleSuggestion(status);
        }

        return false;
    };

    this.setData = function (data) {
        this.data = data;
        sessionData.editingStop.stop = data;
        return this;
    };

    this.getGoogleSuggestion = function () {
        var address = new App.Models.Location(this.data.location).getItemsOfAddress().join(', ');
        var callback = function (results, status) {
            renderResultGoogleSuggestionByStatus(results, status);
        };
        const stopId = this.data.id;
        window.GreenmileReduxStore.dispatch(stopDetailsPopup.requestGoogleSuggestions(routeId, stopId));
        new google.maps.Geocoder().geocode({
            'address': address
        }, callback);

    };

    this.renderSuggestionByEquipmentStoppedAndRenderOnMap = function (coordinates) {
        const markerEquipmentOff = new Greenmile.Marker.EquipmentInOff(map, routeId);
        markerEquipmentOff.customPopup = function (marker) {
            if (sessionData.editingStop) {
                return renderContentPopup(marker);
            } else {
                return this.defaultPopup(arguments[0]);
            }
        };

        markerEquipmentOff.setData(coordinates).render();
        renderSuggestionByEquipmentStopped(coordinates);
        const stopId = this.data.id;
        window.GreenmileReduxStore.dispatch(stopDetailsPopup.completeEquipmentSuggestions(routeId, stopId, coordinates));
    };

    this.getSuggestionByEquipmentStopped = function () {
        return function (context) {
            const stopId = context.data.id;
            window.GreenmileReduxStore.dispatch(stopDetailsPopup.requestEquipmentSuggestions(routeId, stopId));
            const fieldEquipmentOff = rootNode.querySelector('input[name="inputEquipOff"]');
            const minutes = fieldEquipmentOff ? parseInt(fieldEquipmentOff.value, 10) || 0 : 0;
            const coordinates = Monet.Session.RouteDetail.screensList[routeId].coordinates.filterCoordinatesByEquipmentStoppedByMinutes(minutes);
            context.renderSuggestionByEquipmentStoppedAndRenderOnMap(coordinates);
        }(this);
    };

    this.getSuggestionAndRenderResult = function () {
        var renderOnMap = true;
        this.getGoogleSuggestion();
        this.getSuggestionByEquipmentStopped(renderOnMap);
    };

    this.render = function () {

        if (this.rootEl) {
            rootNode.removeChild(this.rootEl);
        }
        return this;

    };

};
